import React from 'react';
import './leaderboard.css';

interface RacerTimeRowProps {
	rank: number;
	userName: string;
	timeString: string;
}

export default function RacerTimeRow({ rank, userName, timeString }: RacerTimeRowProps) {
	return (
		<div className="racerTimeRow">
			<span className="racerTimeRow_label">{rank}: {userName}</span>
			<span className="racerTimeRow_time">{timeString}</span>
		</div>
	);
}
